module.exports = __webpack_public_path__ + "static/media/HCMM807.5a79f135.jpg";